import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handleFlightTimeSelect } from '../../redux/actions/siteSettingsActions';
import ViewHeader from '../viewHeader/viewHeader';
import FlightTimeOption from '../flightTimeOption/flightTimeOption';
import './flightTimePicker.scss';

const flightTimeOptions = {
  short: {
    fill: 25,
  },
  medium: {
    fill: 50,
  },
  long: {
    fill: 75,
  },
}

const FlightTimePicker = ({ onHandleFlightTimeSelect, flightTime, labels }) => {
  const handleSelectFlightTime = (flightOption) => {
    onHandleFlightTimeSelect(flightOption)
  }
  return (
    <div className="vf-view vf-flight-time-picker">

      <ViewHeader header={labels.traitFlightTimeHeader} />

      <div className='vf-flight-time-picker__container'>
        { Object.keys(flightTimeOptions).map(flightTimeKey => {
          const option = flightTimeOptions[flightTimeKey];
          return (
            <FlightTimeOption
              key={flightTimeKey}
              fill={option.fill}
              label={labels[`traitFlightTime_${flightTimeKey}`]}
              flightTimeKey={flightTimeKey}
              active={flightTimeKey === flightTime}
              onSelectFlightTime={handleSelectFlightTime}
              />
          )
        })}
      </div>
    </div>
  )
}

FlightTimePicker.propTypes = {
  flightTime: PropTypes.string,
  onHandleFlightTimeSelect: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    traitFlightTimeHeader: PropTypes.string.isRequired,
    traitFlightTime_short: PropTypes.string.isRequired,
    traitFlightTime_medium: PropTypes.string.isRequired,
    traitFlightTime_long: PropTypes.string.isRequired,
  }).isRequired,
};

FlightTimePicker.defaultProps = {
  flightTime: null,
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    traitFlightTimeHeader: attributeCollection.traitFlightTimeHeader,
    traitFlightTime_short: attributeCollection.traitFlightTime_short,
    traitFlightTime_medium: attributeCollection.traitFlightTime_medium,
    traitFlightTime_long: attributeCollection.traitFlightTime_long,
  }

  return {
    flightTime: siteSettings.filters.selectedFlightTime,
    labels,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHandleFlightTimeSelect: (timeOption) => {
      dispatch(handleFlightTimeSelect(timeOption));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightTimePicker);